import React from 'react'
import { Route, Routes } from 'react-router'
import EssDashboardPage from '../app/ess/EssDashboard/pages/EssDashboardPage'
import EssAttendancePage from '../app/ess/EssAttendance/pages/EssAttendancePage'
import EssWorkReportPage from '../app/ess/EssWorkReport/pages/EssWorkReportPage'

function EssRoutes() {
  return (
    <>
      <Routes>
        {/* Business Details */}
        <Route path="/" element={<EssDashboardPage />}></Route>
        <Route path="/attendance" element={<EssAttendancePage />}></Route>
        <Route path="/work-report" element={<EssWorkReportPage />}></Route>
      </Routes>
    </>
  )
}

export default EssRoutes